module.exports = __webpack_public_path__ + "img/icon09.e2dc9fa9.png";